export enum ReferralSubType {
  ADVISORLESS = 'advisorless',
  ADVISOR_OPTIONAL = 'advisor_optional'
}
